module.exports = __webpack_public_path__ + "media/pl_pl_s3_Halinka.721f72f8.mp3";